import { Script } from "gatsby"
import { useEffect, useMemo, useRef } from "react"

import { Box, useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles"

import { type FC, Container } from ".."

type WidgetProps = {
  id?: string
  variant: "preFooter" | "hero" | "quotes"
  maxWidth?: string
}

const getDataTag = (destination: string): string | null => {
  switch (destination) {
    case "Africa":
      return "Africa"
    case "Middle East":
      return "AfricaAndMiddleEast"
    case "Australia & New Zealand":
      return "Australia-andNewZealand"
    case "South Pacific":
      return "South-Pacific"
    case "Europe":
      return "UKAndEurope"
    case "Asia":
      return "Asia"
    case "Central America":
      return "Central-America"
    case "South America":
      return "CentralAndSouthAmerica"
    case "US & Canada":
      return "USA-and-Canada"
    case "Arctic & Antarctica":
      return "ArcticAndAntarctica"
    case "Indian Ocean":
      return "Indian-Ocean"
    default:
      return null
  }
}

const TrustPilotWidget: FC<WidgetProps> = ({ id, variant }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const ref = useRef<HTMLDivElement>(null)
  const destinationId = getDataTag(id as string)
  const dataTag = destinationId ? { "data-tags": destinationId } : {}
  const widget = useMemo(() => {
    switch (variant) {
      case "hero":
        return (
          <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id="5419b6a8b0d04a076446a9ad"
            data-businessunit-id="547cf0db00006400057be14e"
            data-style-height="24px"
            data-style-width="100%"
            data-theme="dark"
            data-style-alignment="center"
          >
            <a
              href="https://www.trustpilot.com/review/goway.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        )
      case "preFooter":
      case "quotes":
        return (
          <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id="53aa8912dec7e10d38f59f36"
            data-businessunit-id="547cf0db00006400057be14e"
            data-style-height="140px"
            data-style-width="100%"
            data-theme="light"
            data-stars="5"
            data-review-languages="en"
            {...dataTag}
          >
            <a
              href="https://www.trustpilot.com/review/goway.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        )
    }
  }, [])

  useEffect(() => {
    // @ts-ignore
    if (window.Trustpilot) {
      // @ts-ignore
      window.Trustpilot?.loadFromElement(ref?.current, true)
    }
  }, [])

  return (
    <>
      <Script src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async />
      <Box>
        {variant === "preFooter" ? (
          <Container py={{ xs: 20, md: 36 }}>
            <Box>{widget}</Box>
          </Container>
        ) : (
          <Box width="100%">{widget}</Box>
        )}
      </Box>
    </>
  )
}

export default TrustPilotWidget
